import { HTTP } from "@/http-common";
import { createHelpers } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
import { getField, updateField } from "vuex-map-fields";
import { Order } from "@/models/Order";
import { reject } from "q";

export const { mapFields: mapDealerFields } = createHelpers({
  getterType: `order/getField`,
  mutationType: `order/updateField`
});

const state = {
  orders: []
};

const actions = {
  GetAllOrdersForDealer() {
    return new Promise((resolve, dispatch) => {
      HTTP.get("dealerportal/GetAllOrders")
        .then(result => {
          resolve(result.data);
        })
        .catch(error => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error in getting orders for dealer : " + error.message,
              httpStatus: 500
            }),
            { root: true }
          );
          reject(error);
        });
    });
  },
  MoveOrdertoEmployee({ dispatch }, request) {
    return new Promise((resolve, reject) => {
      HTTP.post("DealerPortal/ReassignOrder/", request)
        .then(res => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Orders successfully moved to" + request.dealerID,
              httpStatus: 200
            }),
            { root: true }
          );
          resolve(request);
        })
        .catch(error => {
          dispatch(
            "setMessage",
            new httpError({
              message:
                "Error in moving orders to new employee : " + error.message,
              httpStatus: 500
            }),
            { root: true }
          );
          reject(error);
        });
    });
  },

  MoveCustomertoEmployee({ dispatch }, request) {
    return new Promise((resolve, reject) => {
      HTTP.post("DealerPortal/ReassignCustomer/", request)
        .then(res => {
          if (res.status == 200) {
            dispatch(
              "setMessage",
              new httpError({
                message: "Customer successfully moved to" + request.dealerID,
                httpStatus: 200
              }),
              { root: true }
            );
            resolve(request);
          }
        })
        .catch(error => {
          dispatch(
            "setMessage",
            new httpError({
              message:
                "Error in moving orders to new employee : " + error.message,
              httpStatus: 500
            }),
            { root: true }
          );
          reject(error);
        });
    });
  }
};

const mutations = {
  addRow(state) {
    state.rows.push(new Order());
  },
  clearRows(state) {
    if (typeof state.rows !== "object") state.rows = [];
    state.rows.length = 0;
    state.rows.push(new Order());
  },
  removeRow(state) {
    state.rows.pop();
  },
  setRows(state, upload) {
    state.rows.length = 0;
    state.rows = upload;
  },
  setSession(state, session) {
    state.session = session;
  },
  updateField
};

const getters = {
  getField
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
